/**
 * O cache de módulo dos Primeiros Passos (#387), separado do hook para o `manifestoStore` poder
 * zerá-lo ao sair ou trocar de contexto sem importar o hook, que importa o store.
 */

import type { ChaveDoContexto } from '../stores/chaveDoContexto';
import type { OnboardingStatus } from '../types/onboarding';

let cache: { contexto: ChaveDoContexto; status: OnboardingStatus } | null = null;

export function lerCache(contexto: ChaveDoContexto): OnboardingStatus | undefined {
  return cache && cache.contexto === contexto ? cache.status : undefined;
}

export function gravarCache(contexto: ChaveDoContexto, status: OnboardingStatus): void {
  cache = { contexto, status };
}

/** O cache sobrevive entre renders: sair da sessão, trocar de contexto e os testes o zeram. */
export function clearOnboardingCache(): void {
  cache = null;
}
